import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReportManagement } from '../Api/ReportManagement';
import { Toast } from '../hooks/useToast';


export const fetchReportManagementThunk = createAsyncThunk(
    'reportManangement/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await ReportManagement.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const updateReportManagementThunk = createAsyncThunk(
    'reportManangement/update',
    async (data, { getState, dispatch }) => {
        dispatch(updateReportStatus(data));

        try {
            const { api_token } = getState().profile.data;
            const response = await ReportManagement.update({ data, api_token });
            return response.data
        } catch (err) {
            Toast(err.message, "error", false);
        }
    }
)

export const deleteReportManagementThunk = createAsyncThunk(
    'reportManangement/delete',
    async (slug, { getState }) => {
        try {
            Toast('Deleting report', 'loading', true)
            const { api_token } = getState().profile.data;
            const response = await ReportManagement.delete(slug, api_token);
            Toast('User report deleted successfully', 'success', false)
            return slug
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err.message);
        }
    }
)

const initialState = {
    status: "pending",
    data: [],
}

export const reportManagementSlice = createSlice({
    name: 'reportManagement',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
        updateReportStatus: (state, actions) => {
            return {
                ...state,
                data: [
                    ...state.data.map(item => {
                        const { user_slug, target_user_slug, status } = actions.payload;
                        if (item.source_user_slug === user_slug && item.target_user_slug === target_user_slug) {
                            return {
                                ...item,
                                status,
                            }
                        }
                        else {
                            return item;
                        }
                    })
                ]
            }
        }
    },
    extraReducers: {
        [fetchReportManagementThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchReportManagementThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [updateReportManagementThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [updateReportManagementThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [updateReportManagementThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [deleteReportManagementThunk.fulfilled]: (state, action) => {
            const slug = action.payload;
            state.data = state.data.filter(item => item.slug !== slug)
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, updateReportStatus, resetState } = reportManagementSlice.actions

export default reportManagementSlice.reducer